import { FaPen } from "react-icons/fa";
import "./components.css"
import { useNavigate, useParams } from "react-router-dom";

const AdminProductCard = ({ product }) => {

    const navigate = useNavigate()
    const {name} = useParams()
    return (
        <div className="product-card">
            <div className="product-images">
                {product.files && product.files.length > 0 && (
                    <img
                        src={product.files[0].url}
                        alt={product.title}
                        className="product-image"
                    />
                )}
            </div>

            <div className="product-info">
                <h3>{product.title}</h3>
                <p className="description">{product.description}</p>
                <p><strong>Price:</strong> ${product.price}</p>
                <p><strong>In Stock:</strong> {product.instock ? "Yes" : "No"}</p>
                <p><strong>Discount:</strong> {product.discount}%</p>
                <p><strong>Status:</strong> {product.status}</p>
                <p><strong>Sold:</strong> {product.sold}</p>
                <p><strong>Views:</strong> {product.views}</p>
                <p><strong>Rating:</strong> {product.rating}</p>
                <p><strong>Available:</strong> {product.available ? "Yes" : "No"}</p>
                <p><strong>Created At:</strong> {new Date(product.createdAt).toLocaleString()}</p>
            </div>

            <div className="product-btns">
                    <button className="edit-btn" onClick={()=>navigate(`/b/manage/${name}/products/${product._id}/edit`,{state:{product}})}>
                        <FaPen />
                    </button>
            </div>
        </div>

    );
};

export default AdminProductCard;
